var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "antd";
/**
 * The ProductItem component displays a product item with an icon and a name.
 * E.g. for when displaying a product in a menu or similar context.
 * It supports opening the link in a new tab and styling the item as selected if it is the current product.
 */
export const ProductSelectorItem = (_a) => {
    var { name, href, icon, isCurrentProduct = false } = _a, props = __rest(_a, ["name", "href", "icon", "isCurrentProduct"]);
    return (_jsxs("a", Object.assign({ "data-testid": "te-product-selector_item", className: `
        te-flex te-flex-col te-items-center te-no-underline te-w-[112px] te-rounded-md te-gap-2
        group
      `, href: href || "#", target: "_self", role: "menuitem", "aria-current": isCurrentProduct, "aria-label": name }, props, { children: [icon && (_jsx("div", { "aria-hidden": true, "data-testid": "te-product-selector_item_logo", className: `
            te-leading-[0px] te-rounded-lg te-outline-4
            ${isCurrentProduct
                    ? "te-outline-te-colorPrimary te-outline group-hover:te-outline-te-colorPrimaryHover"
                    : "group-hover:te-outline-te-colorBorder group-hover:te-outline"}
          `, children: icon })), _jsx(Typography.Text, { translate: "no", lang: "x-no-translate", className: "notranslate", children: name })] })));
};
